import CashbacksFilters from './CashbacksFilters';

export default CashbacksFilters;
